import { render } from "./property-tags.vue?vue&type=template&id=1795f148"
import script from "./property-tags.js?vue&type=script&lang=js"
export * from "./property-tags.js?vue&type=script&lang=js"

import "./property-tags.vue?vue&type=style&index=0&id=1795f148&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__